import Alert from "@/common/components/Alert";
import { InfoIcon } from "lucide-react";

const EmptyFiscalDocumentAlert = () => {
  return (
    <Alert
      variant="warning"
      Icon={InfoIcon}
      iconClassName="size-7"
      containerClassName="bg-transparent p-0 gap-2"
      dataTestid="empty_fiscal_document_alert"
    >
      <div className="flex flex-col">
        <p className="text-sm">
          Nota ainda não emitida/Falha na emissão
        </p>

        <p className="text-sm italic font-light">
          Sua nota será gerada e constará aqui em algumas horas.
        </p>
      </div>
    </Alert>
  );
}

export default EmptyFiscalDocumentAlert;
